
// hide on viewport
if ($(window).width() <= 960) {
  $('#nav').attr('hidden', 'true');
} else {
  $('#nav').removeAttr('hidden');
}

$(window).on('resize', function () {
  if ($(window).width() <= 960) {
      $('#nav').attr('hidden', 'true');
  } else {
      $('#nav').removeAttr('hidden');
  }
});

const inputs = document.querySelectorAll('.label__animation input, .label__animation textarea');

inputs.forEach(input => {
  input.addEventListener('input', function() {
    if (this.value) {
      this.classList.add('filled')
    } else {
      this.classList.remove('filled')
    }
  });
});

function cloneValue(cloneSource, cloneTarget) {
  cloneTarget.value = cloneSource.value
}

function cloneAkceptacja(mainCheckbox, secondCheckbox) {
  if (mainCheckbox.checked) {
    secondCheckbox.checked = true;
  } else {
    secondCheckbox.checked = false;
  }
}

// umowsie
if ( document.querySelector('.umowsie__cmp') ) {
  
  // dzien
  let sourceDzien = document.querySelector('#day');
  let targetDzien = document.querySelector('#umowsie-dzien');
  sourceDzien.addEventListener('change', (event) => {
    cloneValue(sourceDzien, targetDzien);
  });
  // miesiac
  let sourceMiesiac = document.querySelector('#month');
  let targetMiesiac = document.querySelector('#umowsie-miesiac');
  sourceMiesiac.addEventListener('change', (event) => {
    cloneValue(sourceMiesiac, targetMiesiac);
  });
  // rok
  let sourceRok = document.querySelector('#year');
  let targetRok = document.querySelector('#umowsie-rok');
  sourceRok.addEventListener('change', (event) => {
    cloneValue(sourceRok, targetRok);
  });
  // telefon
  let sourceTelefon = document.querySelector('#phone');
  let targetTelefon = document.querySelector('#umowsie-telefon');
  sourceTelefon.addEventListener('change', (event) => {
    cloneValue(sourceTelefon, targetTelefon);
  });
  // akceptacja
  let sourceAkcept = document.querySelector('#akceptacja-1');
  let targetAkcept = document.querySelector('#acceptance-2');
  sourceAkcept.addEventListener('change', (event) => {
    cloneAkceptacja(sourceAkcept, targetAkcept);
  });
}

// kontakt
if( document.querySelector('.contact__form_source')) {

  // imie i nazwisko
  let sourceName = document.querySelector('#imie-nazwisko');
  let targetName = document.querySelector('#kontakt-imie-nazwisko');
  sourceName.addEventListener('change', (event) => {
    cloneValue(sourceName, targetName);
  });
  // email
  let sourceEmail = document.querySelector('#email');
  let targetEmail = document.querySelector('#kontakt-email');
  sourceEmail.addEventListener('change', (event) => {
    cloneValue(sourceEmail, targetEmail);
  });
  // tresc
  let sourceTresc = document.querySelector('#tresc-wiadomosci');
  let targetTresc = document.querySelector('#kontakt-tresc');
  sourceTresc.addEventListener('change', (event) => {
    cloneValue(sourceTresc, targetTresc);
  });


  // akceptacja
  let sourceAkcept = document.querySelector('#akceptacja');
  let targetAkcept = document.querySelector('#acceptance-1');
  sourceAkcept.addEventListener('change', (event) => {
    cloneAkceptacja(sourceAkcept, targetAkcept);
  });
}

// ankieta
if ( document.querySelector('.inquiry__form') ) {
  // motyw i kolor
  let targetMotyw = document.getElementById('t-motyw');
  let targetKolor = document.getElementById('t-kolor');
  
  function logMotywy() {
    let radios = document.getElementsByName("motyw");
    let selectedOption;
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) {
        selectedOption = radios[i].value;
      }
    }
    targetMotyw.value = selectedOption;
  }
  function logKolory() {
    let radios = document.getElementsByName("kolor");
    let selectedOption;
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) {
        selectedOption = radios[i].value;
      }
    }
    targetKolor.value = selectedOption;
  }
  
  var motywy = document.getElementsByName("motyw");
  for (var i = 0; i < motywy.length; i++) {
    motywy[i].addEventListener("change", logMotywy);
  }
  var kolory = document.getElementsByName("kolor");
  for (var i = 0; i < kolory.length; i++) {
    kolory[i].addEventListener("change", logKolory);
  }
  
  // potrzeby i dodatkowe
  function getPotrzeby() {
    var checkboxes = document.getElementsByName("potrzeby");
    var selectedValues = [];
    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        selectedValues.push(checkboxes[i].value);
      }
    }
    var textarea = document.getElementById("t-potrzeby");
    textarea.value = selectedValues.join(", ");
  }
  var potrzeby = document.getElementsByName("potrzeby");
  for (var i = 0; i < potrzeby.length; i++) {
    potrzeby[i].addEventListener("change", getPotrzeby);
  }
  
  function getDodatkowe() {
    var checkboxes = document.getElementsByName("dodatkowe");
    var selectedValues = [];
    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        checkboxes[i].value = checkboxes[i].value.replace('dodatkowe-', '')
        checkboxes[i].value = checkboxes[i].value.replace('-', ' ')
        selectedValues.push(checkboxes[i].value);
      }
    }
    var textarea = document.getElementById("t-dodatkowe");
    textarea.value = selectedValues.join(", ");
  }
  var dodatkowe = document.getElementsByName("dodatkowe");
  for (var i = 0; i < dodatkowe.length; i++) {
    dodatkowe[i].addEventListener("change", getDodatkowe);
  }
  
  // miejsce wesela i slubu
  let miejsceWesela = document.getElementsByName('miejsce-wesela');
  let nazwaMiejscaWesela = document.getElementById('nazwa-miejsca-wesele');
  let targetMiejsceWesela = document.getElementById('t-wybrane-m-wesela');
  let targetNazwaMiejscaWesela = document.getElementById('t-nazwa-m-wesela');
  for ( var i = 0; i < miejsceWesela.length; i++ ) {
    miejsceWesela[i].addEventListener("change", function(event) {
      targetMiejsceWesela.value = event.target.value;
      targetNazwaMiejscaWesela.value = '';
      nazwaMiejscaWesela.value = '';
    } )
  }
  function cloneNazwaMiejscaWesela() {
    targetNazwaMiejscaWesela.value = nazwaMiejscaWesela.value;
  }
  nazwaMiejscaWesela.addEventListener("change", cloneNazwaMiejscaWesela )
  
  let miejsceSlubu = document.getElementsByName('miejsce-slubu');
  let nazwaMiejscaSlubu = document.getElementById('nazwa-miejsca-slub');
  let targetMiejsceSlubu = document.getElementById('t-wybrane-m-slubu');
  let targetNazwaMiejscaSlubu = document.getElementById('t-nazwa-m-slubu');
  for ( var i = 0; i < miejsceSlubu.length; i++ ) {
    miejsceSlubu[i].addEventListener("change", function(event) {
      targetMiejsceSlubu.value = event.target.value;
      targetNazwaMiejscaSlubu.value = '';
      nazwaMiejscaSlubu.value = '';
    } )
  }
  function cloneNazwaMiejscaSlubu() {
    targetNazwaMiejscaSlubu.value = nazwaMiejscaSlubu.value;
  }
  nazwaMiejscaSlubu.addEventListener("change", cloneNazwaMiejscaSlubu )

  // dane kontaktowe
  var imieinazwisko = document.getElementById("imie-nazwisko");
  var targetImieinazwisko = document.getElementById("t-imie-nazwisko");
  function cloneImieNazwisko() {
    targetImieinazwisko.value = imieinazwisko.value;
  }
  imieinazwisko.addEventListener("change", cloneImieNazwisko );

  var email = document.getElementById("email");
  var targetEmail = document.getElementById("t-email");
  function cloneEmail() {
    targetEmail.value = email.value;
  }
  email.addEventListener("change", cloneEmail );

  var telefon = document.getElementById("telefon");
  var targetTelefon = document.getElementById("t-telefon");
  function cloneTelefon() {
    targetTelefon.value = telefon.value;
  }
  telefon.addEventListener("change", cloneTelefon );
}